import { Observable } from 'rxjs';

/**
 * Asked when a user signs in holding a local shortlist while their account already has one.
 * The data layer cannot open UI, so the app provides the implementation. Resolves to the codes the
 * account shortlist should hold once the two lists are reconciled. Emitting `undefined` leaves both
 * lists untouched so the question is asked again next time.
 */
export abstract class ShortlistMergePrompt {
  public abstract choose(localCodes: string[], apiCodes: string[]): Observable<string[] | undefined>;
}
